export class Power {
    private constructor(public watts: number) {}

    public static fromWatts(watts: number): Power {
        return new Power(watts);
    }

    public add(other: Power): Power {
        return new Power(this.watts + other.watts);
    }

    public static average(...powers: Power[]): Power | null {
        if (powers.length === 0) {
            return null;
        }
        const totalWatts = powers.reduce((total, power) => total + power.watts, 0);
        return Power.fromWatts(totalWatts / powers.length);
    }

    public equals(other: Power): boolean {
        return this.watts === other.watts;
    }

    public static zero(): Power {
        return new Power(0);
    }
}
